import { apiClient } from './apiClient';

export interface CommentStats {
  daily: number;
  monthly: number;
  yearly: number;
  totalActive: number;
}

export interface CommentUser {
  id: number;
  username: string | null;
}

export interface CommentNews {
  id: number;
  title: string | null;
  slug: string ;
}

export interface Comment {
  id: number;
  content: string;
  isActive: boolean;
  isDelete: boolean;
  parentCommentId: number | null;
  createdAt: string;
  updatedAt: string;
  user: CommentUser;
  news: CommentNews;
}

export interface CommentListResponse {
  data: Comment[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const commentsService = {
  async getStats(): Promise<CommentStats> {
    return apiClient.get<CommentStats>('/comments/stats');
  },

  async searchComments(
    search?: string,
    page: number = 1,
    limit: number = 20,
  ): Promise<CommentListResponse> {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    params.append('page', page.toString());
    params.append('limit', limit.toString());
    return apiClient.get<CommentListResponse>(`/comments?${params.toString()}`);
  },

  async deleteComment(id: number): Promise<void> {
    await apiClient.delete<void>(`/comments/${id}`);
  },
};
